// Third party external dependencies
import Vue from 'vue'
import Vuex from 'vuex'
import Vuetify from 'vuetify'

// External dependencies made my nuskin
import FeatureFlagPlugin from '@nuskin/ns-feature-flags-vue'

// Internal dependencies
import store from './store/index'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(FeatureFlagPlugin)

new Vue({
  render: (h) => h(App),
  store,
}).$mount('#qualifications')
